<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between" xs12 mt-3>
          <h1 class="headline">{{ $t('dtp.title') }}</h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <dtp-table
      class="mt-5"
      :visible-columns="visibleColumns"
      @visible-columns-update="onVisibleColumnsUpdate"
    />
  </v-layout>
</template>

<script>
import DtpTable from '@/components/dtp/DtpTable.vue';

export default {
  components: { DtpTable },
  data: () => ({
    visibleColumns: [],
  }),
  methods: {
    onVisibleColumnsUpdate(columns) {
      this.visibleColumns = columns;
      localStorage.setItem(
        'investor-dtp-visible-columns',
        JSON.stringify(columns),
      );
    },
    setInitialVisibleColumns() {
      const isAlreadySeted = localStorage.getItem(
        'investor-dtp-columns-already-set',
      );

      if (!isAlreadySeted) {
        const defaultColumns = [
          'dtp-date',
          'dtp-insurance-request',
          'dtp-grade-amount',
          'dtp-troubleshooting-amount',
          'dtp-payment-amount',
        ];

        localStorage.setItem(
          'investor-dtp-visible-columns',
          JSON.stringify(defaultColumns),
        );
        localStorage.setItem('investor-dtp-columns-already-set', true);
      }
    },
  },
  created() {
    this.setInitialVisibleColumns();

    const list = localStorage.getItem('investor-dtp-visible-columns');
    if (list) this.visibleColumns = JSON.parse(list);
  },
};
</script>

<style></style>
